<div *ngIf="this.data.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter un ca2</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier un ca2</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-6">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
                <mat-error *ngIf="form.get('code').hasError('maxlength')">
                  Nombre maximum de caractère dépassé
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-6">
          <mat-form-field class="full-width">
              <mat-label>Imputable</mat-label>
              <mat-select formControlName="imputable" required>
                <mat-option [value]="true" >Oui</mat-option>
                <mat-option [value]="false" >Non</mat-option>
              </mat-select>
            </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('maxlength')">
              Nombre maximum de caractère dépassé
            </mat-error>
        </mat-form-field>
      </div>
        
      <div class="col-sm-6">
        <app-autocomplete-with-code-form   
          name="codeCa1" [parent]="form"  
          libelle="Ca1" 
          [objets]="this.data.ca1s" 
          [(objet)]="ca1">
        </app-autocomplete-with-code-form>
      </div>
    </form>
    
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
</div>

